import React from "react";
import { type WeddingLanguage, weddingContent } from "./content";

interface ScheduleProps {
  language: WeddingLanguage;
}

export function Schedule({ language }: ScheduleProps) {
  const content = weddingContent[language].schedule;

  return (
    <section id="schedule" className="wedding-section wedding-section--beige">
      <div className="wedding-container wedding-container--narrow">
        <div className="wedding-header">
          <h2 className="wedding-title">{content.heading}</h2>
          <div className="wedding-divider" />
        </div>

        <div className="schedule-list">
          {content.events.map((event, index) => (
            <div key={index} className="schedule-item">
              <div className="schedule-item__timeWrap">
                <p className="schedule-item__time">{event.time}</p>
              </div>

              <div className="schedule-item__markerWrap">
                <div className="schedule-item__marker" />
                {index !== content.events.length - 1 && (
                  <div className="schedule-item__line" />
                )}
              </div>

              <div className="schedule-item__content">
                <h3 className="schedule-item__title">{event.title}</h3>
                <p className="schedule-item__description">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
